import React from 'react';

export const UserContext = React.createContext({
  user: {},
  login: () => {},
  loginOverride: () => {},
  logout: () => {},
  resetPassword: () => {},
  isLoggedIn: () => {},
  isAuthorized: () => {}
});



// WEBPACK FOOTER //
// ./src/components/auth/UserContext.js